import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PerfilCrezcamosGeneralComponent } from './perfil-crezcamos-general.component';
import { PerfilCrezcamosTelefonosComponent } from './secciones/telefonos/perfil-crezcamos-telefonos.component';
import { PerfilCrezcamosSolicitudesVigentesComponent } from './secciones/solicitudes/perfil-crezcamos-solicitudes-vigentes.component';
import { PerfilCrezcamosSeccionComponent } from './secciones/perfil-crezcamos/perfil-crezcamos-seccion.component';
import { VectoresPagoCrezcamosComponent } from './secciones/historia/vectores-pago-crezcamos/vectores-pago-crezcamos.component';
import { VactoresPagoComponent } from './secciones/historia/vectores-pago/vactores-pago.component';
import { PerfilCrezcamosTotalGarantiasComponent } from './secciones/historia/total-garantias/perfil-crezcamos-total-garantias.component';
import { PerfilCrezcamosEndeudamientoConsultaComponent } from './secciones/historia/endeudamiento-consulta/perfil-crezcamos-endeudamiento-consulta.component';
import { PerfilCrezcamosCreditosVigentesComponent } from './secciones/historia/creditos-vigentes/perfil-crezcamos-creditos-vigentes.component';
import { PerfilCrezcamosCreditosCerradosComponent } from './secciones/historia/creditos-cerrados/perfil-crezcamos-creditos-cerrados.component';
import { PerfilCrezcamosEncabezadoComponent } from './encabezado/perfil-crezcamos-encabezado.component';
import { PerfilCrezcamosBuscadorTerceroComponent } from './buscador-tercero/perfil-crezcamos-buscador-tercero.component';
import { PerfilCrezcamosHistoriaComponent } from './secciones/historia/perfil-crezcamos-historia.component';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { TranslateModule } from '@ngx-translate/core';
import { FileUploadModule } from 'primeng/fileupload';
import { FormSharedModule } from '../../shared/form-shared.module';
import { CuestionarioModule } from '../../shared/cuestionario/cuestionario.module';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LottieComponent } from 'ngx-lottie';
import { AdjuntoModule } from '../../shared/adjuntos/adjunto.module';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { QuillModule } from 'ngx-quill';
import { SharedModule } from '../../shared/shared.module';
import { PerfilCrezcamosModalFirmantesComponent } from './secciones/solicitudes/firmantes/perfil-crezcamos-modal-firmantes.component';
import { PerfilCrezcamosCreditosFirmantesReferenciasComponent } from './secciones/historia/creditos-vigentes/firmantes-referencia/perfil-crezcamos-creditos-firmantes-referencias.component';
import {LocalizacionesModule} from '../../shared/localizaciones/localizaciones.module';


@NgModule({
  declarations: [
    PerfilCrezcamosGeneralComponent,
    PerfilCrezcamosTelefonosComponent,
    PerfilCrezcamosSolicitudesVigentesComponent,
    PerfilCrezcamosSeccionComponent,
    VectoresPagoCrezcamosComponent,
    VactoresPagoComponent,
    PerfilCrezcamosTotalGarantiasComponent,
    PerfilCrezcamosEndeudamientoConsultaComponent,
    PerfilCrezcamosCreditosVigentesComponent,
    PerfilCrezcamosCreditosCerradosComponent,
    PerfilCrezcamosEncabezadoComponent,
    PerfilCrezcamosBuscadorTerceroComponent,
    PerfilCrezcamosHistoriaComponent,
    PerfilCrezcamosModalFirmantesComponent,
    PerfilCrezcamosCreditosFirmantesReferenciasComponent
  ],
  imports: [
    CommonModule,
    ButtonModule,
    SharedModule,
    TableModule,
    TranslateModule,
    FileUploadModule,
    FormsModule,
    FormSharedModule,
    CuestionarioModule,
    DialogModule,
    InputTextModule,
    ReactiveFormsModule,
    LottieComponent,
    AdjuntoModule,
    ConfirmDialogModule,
    QuillModule,
    LocalizacionesModule,
  ],
  exports: [
    PerfilCrezcamosGeneralComponent,
    PerfilCrezcamosTelefonosComponent,
    PerfilCrezcamosSolicitudesVigentesComponent,
    PerfilCrezcamosSeccionComponent,
    VectoresPagoCrezcamosComponent,
    VactoresPagoComponent,
    PerfilCrezcamosTotalGarantiasComponent,
    PerfilCrezcamosEndeudamientoConsultaComponent,
    PerfilCrezcamosCreditosVigentesComponent,
    PerfilCrezcamosCreditosCerradosComponent,
    PerfilCrezcamosEncabezadoComponent,
    PerfilCrezcamosBuscadorTerceroComponent,
    PerfilCrezcamosHistoriaComponent,
    PerfilCrezcamosCreditosFirmantesReferenciasComponent
  ]
})
export class PerfilCrezcamosModule { }
